module.exports = require('./BigTabsView');
